module.exports = require('./BigTabsView');
